import { useQuery } from 'convex/react'; // CROSS_IMPORT_JUSTIFIED: convex/react is the official client-side React bindings package, not a server module
import { api } from '@convex/_generated/api';
import type { Id } from '@convex/_generated/dataModel';
import type { ILeadInsuranceRequest } from '@/@types/leadInsuranceRequest';

export function useLeadInsuranceRequests(leadId: Id<'leads'> | null): {
  requests: ILeadInsuranceRequest[] | undefined;
  isLoading: boolean;
} {
  const data = useQuery(api.leadInsuranceRequests.queries.listByLead, leadId ? { leadId } : 'skip');
  return {
    requests: data,
    isLoading: data === undefined,
  };
}
